import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvoices = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15 2.7207V7.7207H20",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 2.28027,
			width: 16,
			height: 19.4401,
			rx: 4,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.9438 14.8503C14.9438 16.2279 13.8798 17.1127 12.1886 17.1687V18.5127H11.2814V17.1239C9.63505 16.8999 8.57105 15.9479 8.48145 14.5815H9.85905C9.95752 15.238 10.4408 15.702 11.2253 15.8902C11.5169 15.9838 11.8623 16.0185 12.1877 15.9821C12.2357 15.9767 12.2829 15.9694 12.329 15.9604C13.1455 15.8845 13.5774 15.5115 13.5774 14.9175C13.5774 14.3015 13.0958 14.0551 12.3342 13.8199L12.2191 13.7844C12.0816 13.7391 11.9318 13.6967 11.7693 13.6569C11.6374 13.6251 11.5038 13.5797 11.3759 13.5362C11.2497 13.4933 11.1291 13.4522 11.0211 13.428L10.9992 13.4213C10.0797 13.1417 8.70545 12.7238 8.70545 11.2215C8.70545 9.98948 9.67985 9.07108 11.2814 8.99268V7.73828H12.1886V9.03748C13.6894 9.26148 14.619 10.2247 14.7086 11.6695H13.3422C13.3055 11.1087 13.0348 10.6686 12.5425 10.4175C12.2471 10.2636 11.8661 10.1726 11.5 10.1726C11.3996 10.1726 11.302 10.1812 11.2082 10.1974C10.4891 10.2698 10.0382 10.6125 10.0382 11.1543C10.0382 11.7554 10.5629 11.9553 11.1981 12.1582C11.3332 12.207 11.4808 12.2545 11.6404 12.3015C11.7675 12.3269 11.8958 12.3726 12.0195 12.4166C12.0771 12.4371 12.1337 12.4572 12.1886 12.4748V12.4759L12.6702 12.6215C13.779 12.9687 14.9438 13.3719 14.9438 14.8503Z",
			fill: "currentColor"
		})
	]
});
export default SvgInvoices;
